// extracted by mini-css-extract-plugin
export var divider = "_gr-7";
export var itemsToggle = "_gr-8";
export var mergeModal = "_gr-1";
export var optionCard = "_gr-4";
export var radioGroup = "_gr-6";
export var radioOption = "_gr-0";
export var selected = "_gr-5";
export var shipmentOptions = "_gr-2";
export var tableOptions = "_gr-3";